import React, { useEffect, useState } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import AppDatagridTable from '../../../layouts/AppDatagridTable';

import { useDispatch, useSelector } from 'react-redux';
import { getPageContent, submitForm } from '../../../../store/actions/ProductActions';
import AppLoader from '../../../pages/AppLoader';
import { pincodesTable } from '../../../../utils/tableElements';
import moment from 'moment';
import { convertTo12HourFormat } from '../../../../utils/appConstants';
import AppDialogBox from '../../../pages/AppDialogBox';

import { Button } from '@mui/material';
import { addFunctionsToCols } from '../../../../utils/appFunctions';

const ManagePincodes = () => {
  const dispatch = useDispatch();

  const [tableData, setTableData] = useState({});
  const [open, setOpen] = useState(false);
  const [actionId, setActionId] = useState();
  const [values, setValues] = useState({});

  const token = useSelector(state => state?.auth?.token);
  const btnLoaderOne = useSelector(state => state?.app?.btnLoaderOne);
  const pincodes = useSelector(state => state?.products?.pincodes);

  useEffect(() => {
    dispatch(getPageContent('getAllPincodes', token));
    addFunctionsToCols(pincodesTable, editBlogs, 'editIcon');
    addFunctionsToCols(pincodesTable, deleteBlogs, 'deleteIcon');
  }, []);

  useEffect(() => {
    if (pincodes) {
      setTableData({ columns: pincodesTable, rows: pincodes });
      setOpen(false);
    }
  }, [pincodes]);

  function editBlogs(row, col) {
    setValues({
      pinCode: row?.pinCode,
      shipmentPrice: row?.shipmentPrice,
      area: row?.area,
    });
    setActionId(row?._id);
    setOpen(true);
  }

  function deleteBlogs(row, col) {
    if (window.confirm('Are you sure you want to delete this blog?')) {
      const submitValues = { isActive: false };
      dispatch(submitForm('editPincode', token, submitValues, row?._id));
    }
  }

  function clearForm() {
    setValues({ pinCode: '', shipmentPrice: '', area: '' });
  }

  const handleOpenModal = () => {
    clearForm();
    setOpen(true);
    setActionId();
  };

  const handleSubmit = e => {
    e.preventDefault();
    const type = actionId ? 'editPincode' : 'createPincode';

    let submitValues = { additionalPath: values?.title, ...values };
    dispatch(submitForm(type, token, submitValues, actionId));
  };

  const handleChange = e => {
    setValues({ ...values, [e?.target?.name]: e?.target?.value });
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  return pincodes ? (
    <div>
      <AppTitle title='Pincode Management' from='Home' to='Pincode' />

      <div className='container my-5'>
        <div className='text-right mb-3'>
          <button className='btn btn-dark ' onClick={handleOpenModal}>
            Add Pincode
          </button>
        </div>

        <AppDatagridTable tableData={tableData} />

        <AppDialogBox
          title={actionId ? 'Edit Product' : 'Add Product'}
          setOpen={setOpen}
          open={open}
          size='md'
          disableBackdropClick={false}
        >
          <form onSubmit={handleSubmit}>
            <div className='form-group'>
              <label>Pin Code *</label>
              <input
                type='text'
                placeholder='Enter Pincode'
                className='form-control'
                required
                name='pinCode'
                value={values?.pinCode}
                onChange={handleChange}
              />
            </div>

            <div className='form-group'>
              <label>Shipment Price *</label>
              <input
                type='number'
                placeholder='Enter Price'
                className='form-control'
                required
                name='shipmentPrice'
                value={values?.shipmentPrice}
                onChange={handleChange}
              />
            </div>

            <div className='form-group'>
              <label>Shipment Area *</label>
              <input
                type='text'
                placeholder='Enter area'
                className='form-control'
                required
                name='area'
                value={values?.area}
                onChange={handleChange}
              />
            </div>

            <div className='text-right mt-2 mb-3'>
              <Button variant='contained' type='submit' disabled={btnLoaderOne}>
                {btnLoaderOne ? 'Submitting...' : 'Submit'}
              </Button>

              <Button variant='contained' className='mx-2' color='error' onClick={handleModalClose}>
                Cancel
              </Button>
            </div>
          </form>
        </AppDialogBox>
      </div>
    </div>
  ) : (
    <AppLoader />
  );
};

export default ManagePincodes;
